const mutations = {
  ["DRAWER"](state, payload) {
    state.drawer = payload;
  },
  ["myexcelActivationMut"](state, payload) {
    state.myexcelActivation = payload;
  },
  ["EXTENDEDSEARCH"](state, payload) {
    state.extended_search = payload;
  },
  ["DROPDOWNDATAAPI"](state, payload) {
    state.dropDownData = payload;
  },
  ["isAuthLoginMUT"](state, payload) {
    state.isAuthLogin = payload;
  },
  ["DeliveryDirectMailFlagActions"](state, payload) {
    state.directMailDeliveryBoxFlag = payload;
  },
  ["PrintPublicationTypeBoxFlag"](state, payload) {
    state.printPublicationTypeBoxFlag = payload;
  },
  ["EmailElectronicTypeBoxFlagActions"](state, payload) {
    state.emailElectronicTypeBoxFlag = payload;
  },
  ["SocialNetworkNameBoxFlagActions"](state, payload) {
    state.socialNetworkNameBoxFlag = payload;
  },
  ["BankingOptionBoxFlagActions"](state, payload) {
    state.isBankingOptionOn = payload;
  },
  ["CreditOptionBoxFlagActions"](state, payload) {
    state.isCreditOptionOn = payload;
  },
  ["UserSearchDateMut"](state, payload) {
    state.userSearchDate = payload;
  },
  ["TimeSelectionMut"](state, payload) {
    if (state.userTime.length !== 2) {
      state.userTime.push(payload);
    }
    // else {
    //   state.userTime = payload;
    // }
  },
  ["affinityBoxesMut"](state, payload) {
    state.affinityBoxesFlag = payload;
  },
  ["mediaAPIPayloadMut"](state, payload) {
    // console.log(payload, "media payload");
    if (payload === "e") {
      state.mediaAPIPayload = [];
    } else if (!state.mediaAPIPayload.includes(payload)) {
      state.mediaAPIPayload.push(payload);
      // console.log(payload, "pa");
    } else {
      let ind = state.mediaAPIPayload.findIndex((f) => f === payload);
      // console.log(ind, "media ind");
      state.mediaAPIPayload.splice(ind, 1);
    }
  },
  ["sectorAPIPayloadMut"](state, payload) {
    // console.log(payload, "sect");
    if (payload === "e") {
      state.sectorAPIPayload = [];
    } else if (!state.sectorAPIPayload.includes(payload)) {
      state.sectorAPIPayload.push(payload);
    } else {
      let ind = state.sectorAPIPayload.findIndex((f) => f === payload);
      // console.log(ind, "ind");
      state.sectorAPIPayload.splice(ind, 1);
    }
    // console.log("sec payload", state.sectorAPIPayload);
  },
  ["audienceAPIPayloadMut"](state, payload) {
    // console.log(payload, "aud");
    // console.log(state.audienceAPIPayload, "state");
    if (payload === "e") {
      state.audienceAPIPayload = [];
    } else if (!state.audienceAPIPayload.includes(payload)) {
      state.audienceAPIPayload.push(payload);
    } else {
      let ind = state.audienceAPIPayload.findIndex((f) => f === payload);
      // console.log(ind, 90909);
      state.audienceAPIPayload.splice(ind, 1);
    }
    // console.log(state.audienceAPIPayload, "aud payload");
  },
  ["searchResultMut"](state, payload) {
    state.searchResult = payload;
  },

  ["searchAPIBodyMut"](state, payload) {
    Object.keys(payload).find((key) => {
      if (key === "m") {
        Object.keys(state.searchAPIBody).find((k) => {
          if (k == "mchanne_id") {
            if (!state.searchAPIBody[k].includes(payload[key])) {
              // console.log("SWs", payload[key]);
              state.searchAPIBody[k].push(payload[key]);
            } else {
              // let ind = state.searchAPIBody[k].findIndex(
              //   (f) => f === payload[key]
              // );
              // state.searchAPIBody[k].splice(ind, 1);
            }
          }
        });
      } else if (key === "s") {
        Object.keys(state.searchAPIBody).find((k) => {
          if (k == "sector_id") {
            if (!state.searchAPIBody[k].includes(payload[key])) {
              state.searchAPIBody[k].push(payload[key]);
            } else {
              // let ind = state.searchAPIBody[k].findIndex(
              //   (f) => f === payload[key]
              // );
              // state.searchAPIBody[k].splice(ind, 1);
            }
          }
        });
      } else if (key === "a") {
        Object.keys(state.searchAPIBody).find((k) => {
          if (k == "mpanel_id") {
            if (!state.searchAPIBody[k].includes(payload[key])) {
              state.searchAPIBody[k].push(payload[key]);
            } else {
              // let ind = state.searchAPIBody[k].findIndex(
              //   (f) => f === payload[key]
              // );
              // state.searchAPIBody[k].splice(ind, 1);
            }
          }
        });
      } else if (key == "product_headline" && key !== "dts_val") {
        // console.log("nahi hai dts");
        state.searchAPIBody = { ...state.searchAPIBody, ...payload };
      } else if (key !== "product_headline" && key == "dts_val") {
        // console.log("nahi hai product headline");
        state.searchAPIBody = { ...state.searchAPIBody, ...payload };
      } else if (key == "product_headline" && key == "dts_val") {
        // console.log("dono hai");
        state.searchAPIBody = { ...state.searchAPIBody, ...payload };
      } else if (key == "company_id") {
        state.searchAPIBody = { ...state.searchAPIBody, ...payload };
      }
      // console.log("SWs.", state.searchAPIBody);
    });
  },
  ["OldPageValueMut"](state, payload) {
    state.oldPageValue = payload;
  },
  ["ocrFullTextPayloadMut"](state, payload) {
    state.ocrFullTextPayload = payload;
  },
  ["SnackbarFlagMut"](state, payload) {
    state.SnackbarFlag = payload;
  },
  ["toMonthMut"](state, payload) {
    state.toMonth = payload;
  },
  ["toDateMut"](state, payload) {
    state.toDate = payload;
  },
  ["toYearMut"](state, payload) {
    state.toYear = payload;
  },
  ["monthSelectionPayloadStateMut"](state, payload) {
    if (payload !== 0) {
      state.monthSelectionPayloadState = payload;
    } else {
      state.monthSelectionPayloadState = {};
    }
  },
  ["fromYearMut"](state, payload) {
    state.fromYear = payload;
  },
  ["fromMonthMut"](state, payload) {
    state.fromMonth = payload;
  },
  ["fromDateMut"](state, payload) {
    state.fromDate = payload;
  },
  ["CompanyDataMut"](state, payload) {
    state.companyData = payload;
  },
  ["AffinityDataMut"](state, payload) {
    state.affinityData = payload;
  },
  ["ProductNamesDataMut"](state, payload) {
    state.productNameData = payload;
  },
  ["communicationTypeSelectionMut"](state, payload) {
    state.communicationTypeSelection = {
      ...state.communicationTypeSelection,
      ...payload,
    };
  },
  ["DeliveryMethodPayloadMut"](state, payload) {
    state.DeliveryMethodPayload = payload;
  },
  ["groupSizePayloadPayloadMut"](state, payload) {
    state.groupSizePayload = payload;
  },
  ["electronicTypePayloadMut"](state, payload) {
    // console.log(typeof payload, "elec pay", payload);
    if (payload === "e") {
      state.electronicTypePayload = [];
    } else if (!state.electronicTypePayload.includes(payload)) {
      state.electronicTypePayload.push(payload);
    }
    // console.log(state.electronicTypePayload, "elec pay");
  },
  ["PublicationTypePayloadMut"](state, payload) {
    state.PublicationTypePayload = payload;
  },
  ["PublicationNamePayloadMut"](state, payload) {
    // console.log(payload, " payy pub");
    state.PublicationNamePayload = [];
    if (payload.length > 0) {
      for (let i = 0; i < payload.length; i++) {
        state.PublicationNamePayload.push(payload[i].id);
      }
    }
  },
  ["PublicationNameSelectedMut"](state, payload) {
    // console.log(payload, " payy pub");
    state.PublicationNameSelected = [];
    if (payload.length > 0) {
      for (let i = 0; i < payload.length; i++) {
        state.PublicationNameSelected.push(payload[i]);
      }
    }
  },
  ["productCompaniesNamesMut"](state, payload) {
    state.productCompaniesNames = payload;
  },
  ["personalizedRadiosMut"](state, payload) {
    state.personalizedRadios = payload;
  },
  ["panelistTextMut"](state, payload) {
    state.panelistText = payload;
  },
  ["panelistRadioMut"](state, payload) {
    state.panelistRadio = payload;
  },
  ["issueTypePayloadMut"](state, payload) {
    state.issueTypePayload = payload;
  },
  ["socialPayloadMut"](state, payload) {
    state.socialPayload = payload;
  },
  ["networkNamePayloadMut"](state, payload) {
    state.networkNamePayload = payload;
  },
  ["introductoryPricingPayloadMut"](state, payload) {
    state.introductoryPricingPayload = payload;
  },
  ["ActionPayload"](state, payload) {
    // console.log("WWs", payload);
    state.actionPayload = payload;
  },
  ["searchDatePayloadMut"](state, payload) {
    state.searchDate = payload;
  },
  ["betweenTimePayloadMut"](state, payload) {
    // console.log(payload, "payload");
    if (payload.length !== 0) {
      const [time, period] = payload.split(" ");
      const [hours, minutes] = time.split(":");

      // Convert hours to an integer
      let hour = parseInt(hours, 10);

      // Adjust for PM (add 12 hours) if it's in the afternoon
      if (period.toLowerCase() === "pm") {
        hour = (hour % 12) + 12;
      } else {
        // Handle midnight (12:00 AM)
        if (hour === 12) {
          hour = 0;
        }
      }

      // Format the 24-hour time
      const time24Hour = `${hour.toString().padStart(2, "0")}:${minutes}:00`;
      state.betweenTime = time24Hour;
    } else {
      state.betweenTime = "";
    }
  },
  ["AndTimePayloadMut"](state, payload) {
    if (payload.length !== 0) {
      const [time, period] = payload.split(" ");
      const [hours, minutes] = time.split(":");

      // Convert hours to an integer
      let hour = parseInt(hours, 10);

      // Adjust for PM (add 12 hours) if it's in the afternoon
      if (period.toLowerCase() === "pm") {
        hour = (hour % 12) + 12;
      } else {
        // Handle midnight (12:00 AM)
        if (hour === 12) {
          hour = 0;
        }
      }

      // Format the 24-hour time
      const time24Hour = `${hour.toString().padStart(2, "0")}:${minutes}:00`;
      state.AndTime = time24Hour;
    } else {
      state.AndTime = "";
    }
  },
  ["searchedBodyDataMut"](state, payload) {
    state.searchedBodyData = payload;
  },
  ["sectorAllMut"](state, payload) {
    state.sectorAll = payload;
  },
  ["searchBtnDisabledFlagMut"](state, payload) {
    state.searchBtnDisabledFlag = payload;
  },
  ["mediaAllMut"](state, payload) {
    state.mediaAll = payload;
  },
  ["audienceAllMut"](state, payload) {
    state.audienceAll = payload;
  },
  ["rawAdditionalMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.raw_additional = payload;
  },
  ["rawsearchBtnFlagMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.searchBtnFlag = payload;
  },
  ["offerOriginMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.offerOriginChanged = payload;
  },
  ["searchCriteriaGlobalMut"](state, payload) {
    state.searchCriteriaGlobal = payload;
  },
  ["SearchCritertiaMutation"](state, payload) {
    // console.log("Search Criteria Start", payload);
    let searchCriteria = [];
    if (payload.val.length > 0) {
      for (let i = 0; i < payload.val.length; i++) {
        if (payload.column === "Media Channel") {
          const stat = payload.entirs.filter(
            (e) => e.mChannelID === Number(payload.val[i])
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].mChannelName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Sectors") {
          const stat = payload.entirs.filter(
            (e) => e.sectorID === Number(payload.val[i])
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].sectorName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Audience") {
          const stat = payload.entirs.filter(
            (e) => e.mPanelID === Number(payload.val[i])
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].mPanelName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Ancillary Products") {
          const stat = payload.entirs.filter(
            (e) => e.ancillary_id === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].ancillary_name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "State/Province") {
          const stat = payload.entirs.filter(
            (e) => e.stateID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].stateName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Group Size") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "FicoScore") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].score_range);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "CreditVision") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].score_range);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "VantageScore") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].score_range);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Electronic Type") {
          const stat = payload.entirs.filter(
            (e) => e.electronic_id === Number(payload.val[i])
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].electronic_name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Publication Type") {
          const stat = payload.entirs.filter(
            (e) => e.print_typeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].print_typeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Card Network") {
          const stat = payload.entirs.filter(
            (e) => e.CardTypeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].CardTypeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Application Type") {
          const stat = payload.entirs.filter(
            (e) => e.ApplicationTypeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].ApplicationTypeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Postage Type") {
          const stat = payload.entirs.filter(
            (e) => e.packageTypeId === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].packageName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Postage") {
          const stat = payload.entirs.filter(
            (e) => e.postageId === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].postageName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Delivery Type") {
          const stat = payload.entirs.filter(
            (e) => e.deliveryTypeId === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].deliveryTypeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Pre-Sorted") {
          const stat = payload.entirs.filter(
            (e) => e.presortedId === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].presortedName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Response Mechanism") {
          const stat = payload.entirs.filter(
            (e) => e.responseMechID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].responseMechName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Introductory Pricing") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].value);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "EDC / LDC / TDSP") {
          const stat = payload.entirs.filter(
            (e) => e.edc_id === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].edc_name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Energy - Rate Type") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Offer Price (¢ per kWh)") {
          const stat = payload.entirs.filter((e) => e === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].OfferPriceName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Energy - Term Length") {
          const stat = payload.entirs.filter(
            (e) => e.TermLengthID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].TermLengthName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Communication Type") {
          const stat = payload.entirs.filter((e) => e.ID === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].type);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Mailing Type") {
          const stat = payload.entirs.filter(
            (e) => e.mTypeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].mTypeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Business Content") {
          const stat = payload.entirs.filter(
            (e) => e.key_id === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].text_value);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Age") {
          const stat = payload.entirs.filter(
            (e) => e.age_pID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].age_pname);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "DMA®") {
          const stat = payload.entirs.filter((e) => e.code === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].description);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Income") {
          const stat = payload.entirs.filter(
            (e) => e.incomeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].incomeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (
          payload.column === "Income Producing Assets Segment Code *R*"
        ) {
          const stat = payload.entirs.filter((e) => e.code === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].description);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Value Score") {
          const stat = payload.entirs.filter((e) => e.code === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].description);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Face Amount") {
          const stat = payload.entirs.filter((e) => e.fa_id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].fa_name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Term Length") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].name);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Riders") {
          const stat = payload.entirs.filter(
            (e) => e.ridersID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].ridersName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Issue Type") {
          const stat = payload.entirs.filter(
            (e) => e.IssueTypeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].IssueTypeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Target Markets") {
          const stat = payload.entirs.filter((e) => e.id === payload.val[i]);
          if (stat) {
            searchCriteria.push(" " + stat[0].value);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Delivery Method") {
          const stat = payload.entirs.filter(
            (e) => e.delmethid === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].delmethname);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Rewards Program Emphasis") {
          // console.log(payload, "payloadaaaasearc");
          const stat = payload.entirs.filter(
            (e) => e.RewardTypeID === payload.val[i]
          );
          if (stat) {
            searchCriteria.push(" " + stat[0].RewardTypeName);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Affinity/Association Category") {
          searchCriteria.push(" " + payload.val[i].AffinityCategoryName);
          state.searchCriteria[`${payload.column}`] = searchCriteria;
        } else if (payload.column === "Affinity/Association Sub-Category") {
          searchCriteria.push(" " + payload.val[i].AffinityCategoryName);
          state.searchCriteria[`${payload.column}`] = searchCriteria;
        } else if (payload.column === "Category") {
          const stat = payload.entirs.filter(
            (e) => e.id === Number(payload.val[i])
          );
          // console.log(stat, "stat", stat[0].name);
          if (Object.keys(stat).length > 0) {
            if (Object.keys(stat[0].name !== undefined)) {
              searchCriteria.push(" " + stat[0]?.name);
              const fin = Array.from(
                new Set(searchCriteria.map((item) => item))
              ).toString();
              state.searchCriteria[`${payload.column}`] = fin;
            }
          }
        } else if (payload.column === "Sub Category") {
          const stat = payload.entirs.filter(
            (e) => e.id === Number(payload.val[i])
          );
          if (stat) {
            let temp = stat[0].name.slice(
              stat[0].name.search(" >> ") + 3,
              stat[0].name.length
            ); // this is deleting text before >>
            searchCriteria.push(" " + temp);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "Sub Sub Category") {
          const stat = payload.entirs.filter(
            (e) => e.id === Number(payload.val[i])
          );
          if (stat) {
            let temp = stat[0].name.slice(
              stat[0].name.search(" >> ") + 3,
              stat[0].name.length
            );
            searchCriteria.push(" " + temp);
            const fin = Array.from(
              new Set(searchCriteria.map((item) => item))
            ).toString();
            state.searchCriteria[`${payload.column}`] = fin;
          }
        } else if (payload.column === "ocr") {
          state.searchCriteria[`${payload.column}`] = payload.val;
        } else if (payload.column === "full") {
          state.searchCriteria[`${payload.column}`] = payload.val;
        }
      }
    } else {
      delete state.searchCriteria[payload.column];
    }

    // console.log("Search Criteria Start.", state.searchCriteria[payload.column]);
    // console.log("Search Criteria end", state.searchCriteria);
  },
  ["SearchCritertiaSingleSelectMutation"](state, payload) {
    // console.log("Search new", payload);
    if (payload.column === "Campaign Language") {
      if (payload.val !== 0) {
        const stat = payload.entirs.filter((e) => e.id === payload.val);
        if (stat) {
          state.searchCriteria[`${payload.column}`] = stat[0].text_value;
        }
      } else {
        delete state.searchCriteria[payload.column];
      }
    }
    if (payload.column === "Network Name") {
      if (payload.val !== 0) {
        const stat = payload.entirs.filter((e) => e.id === payload.val);
        if (stat) {
          state.searchCriteria[`${payload.column}`] = stat[0].id;
        }
      } else {
        delete state.searchCriteria[payload.column];
      }
    }
    if (payload.column === "Social Media Ad Type") {
      if (payload.val !== 0) {
        const stat = payload.entirs.filter((e) => e.id === payload.val);
        console.log(stat, "st");
        if (stat) {
          state.searchCriteria[`${payload.column}`] = stat[0].text_value;
        }
      } else {
        delete state.searchCriteria[payload.column];
      }
    }
    if (payload.column === "Offer Origin") {
      if (payload.val !== "Select One") {
        const stat = payload.entirs.filter((e) => e.oo_id === payload.val);
        if (stat) {
          state.searchCriteria[`${payload.column}`] = stat[0].oo_name;
        }
      } else {
        delete state.searchCriteria[payload.column];
      }
    }
    if (payload.column === "Offer Origin") {
      if (payload.val !== "Select One") {
        const stat = payload.entirs.filter((e) => e.oo_id === payload.val);
        if (stat) {
          state.searchCriteria[`${payload.column}`] = stat[0].oo_name;
        }
      } else {
        delete state.searchCriteria[payload.column];
      }
    }
  },
  ["SearchCriteriaMultiTextboxes"](state, payload) {
    // console.log("SearchCriteriaMultiTextboxes", payload, payload.value.length);
    if (payload.event === "Company") {
      if (payload.value.length > 0) {
        state.searchCriteria["Company"] = payload.value
          .map((e) => `"${e.name}"`)
          .join(" or ");
      } else {
        delete state.searchCriteria[payload.event];
      }
    }
    if (payload.event === "Affinity/Association ") {
      if (payload.value.length > 0) {
        state.searchCriteria["Affinity/Association "] = payload.value
          .map((e) => `"${e.name}"`)
          .join(" or ");
      } else {
        delete state.searchCriteria[payload.event];
      }
    }
    if (payload.event === "Publication Name") {
      if (payload.value.length > 0) {
        state.searchCriteria["Publication Name"] = payload.value
          .map((e) => `"${e.name}"`)
          .join(" or ");
      } else {
        delete state.searchCriteria[payload.event];
      }
    }
    if (payload.event === "Product Name") {
      if (payload.value.length > 0) {
        state.searchCriteria["Product Name"] = payload.value
          .map((e) => `"${e.productName}"`)
          .join(" or ");
      } else {
        delete state.searchCriteria[payload.event];
      }
    }
    // console.log("SearchCriteriaMultiTextboxes.", state.searchCriteria);
  },
  ["previousPaginationFlagMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.previousPaginationFlag = payload;
  },
  ["nextPaginationFlagMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.nextPaginationFlag = payload;
  },
  ["lastPaginationFlagMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.lastPaginationFlag = payload;
  },
  ["lastPageNoMut"](state, payload) {
    // console.log("FICOCreditVantage", payload);
    state.lastPageNo = payload;
  },
  ["searchResultOptionMut"](state, payload) {
    state.searchResultOption = payload;
  },
  ["lastResultFieldsMut"](state, payload) {
    state.lastResultFields = payload;
  },
  ["SearchAgainFlagMut"](state, payload) {
    state.SearchAgainFlag = payload;
  },
  ["OcrFullTextSearchMut"](state, payload) {
    state.OcrFullTextSearch = payload;
  },
  ["UserRawDataMut"](state, payload) {
    // console.log(payload.exclude_search, "payaa");
    // state.userRawData = payload;
    // console.log(state.roleUpdatedRawData, 22);
    setTimeout(() => {
      // console.log("len", state.roleUpdatedRawData["additional_exclude"]);
      if (state.roleUpdatedRawData["additional_exclude"].length > 0) {
        // console.log(state.roleUpdatedRawData["additional_exclude"], 99);
        let additionalExcludeRaw = payload.exclude_search;
        // console.log("lpay", additionalExcludeRaw);
        let excludenames = [];
        for (let o in additionalExcludeRaw) {
          // console.log(o, 233111);
          let found = state.roleUpdatedRawData["additional_exclude"].includes(
            Number(o)
          );
          // console.log(found, "found", additionalExcludeRaw[o]);
          if (!found) {
            // excludenames.push(additionalExcludeRaw[o]);
            // state.userRawData["exludes"].push(additionalExcludeRaw[o]);
            // console.log("222");
            // console.log(111, additionalExcludeRaw[o]);
            // excludenames.push(additionalExcludeRaw[o]);
            // excludenames = { ...excludenames, [o]: additionalExcludeRaw[o] };
            excludenames.push({ id: o, fieldName: additionalExcludeRaw[o] });
          }
        }
        // obj = { ...obj, [Object.keys(obj).length]: input }

        // console.log(excludenames, "excludenames");
        state.roleUpdatedRawData = {
          ...state.roleUpdatedRawData,
          excludenames,
        };
      }
      // console.log(state.roleUpdatedRawData, 55);
    }, 1000);
  },
  ["UpdatedRawDataMut"](state, payload) {
    //media
    if (payload.mediachannel.length > 0) {
      setTimeout(() => {
        let mediaChanRaw = state.dropDownData.mediachannel;
        for (let m of mediaChanRaw) {
          let found = payload.mediachannel.includes(m.mChannelID);
          if (found) {
            state.roleUpdatedRawData["media"].push(m);
          }
        }
      }, 5000);
    }
    //sector
    if (payload.sector.length > 0) {
      setTimeout(() => {
        // console.log(state.dropDownData, 8833);
        let sectorRaw = state.dropDownData.sectors;
        for (let s of sectorRaw) {
          let found = payload.sector.includes(s.sectorID);
          if (found) {
            state.roleUpdatedRawData["sector"].push(s);
          }
        }
      }, 5000);
    }
    //audience
    if (payload.audience.length > 0) {
      setTimeout(() => {
        let audienceRaw = state.dropDownData.audience;
        for (let a of audienceRaw) {
          let found = payload.audience.includes(a.mPanelID);
          if (found) {
            state.roleUpdatedRawData["audience"].push(a);
          }
        }
      }, 5000);
    }
    //additional exclude
    // console.log(payload.additional_exclude, "pay", state.roleUpdatedRawData);
    state.roleUpdatedRawData["additional_exclude"] = payload.additional_exclude;
    // state.roleUpdatedRawData = payload;
  },
  ["searchDateSelectionMut"](state, payload) {
    // console.log("pay", payload);
    let keys = Object.keys(payload);
    //dropdowndata
    if (keys.includes("dropdownDate")) {
      let val = Object.values(payload);
      // console.log(val, "val");
      // let cd = new Date();
      // let date = cd.getDate();
      // let month = cd.getMonth() + 1;
      // let year = cd.getFullYear();
      // let p = moment(payload["dropdownDate"].slice(0, 10));
      // let currentDate = moment(`${year}-${month}-${date}`);
      // let diff = `${p.diff(currentDate, "days")}`;
      // console.log(diff, "diff");
      if (val.includes("1week")) {
        state.searchDateSelection["dropdownDate"] = "1week";
      } else if (val.includes("2week")) {
        state.searchDateSelection["dropdownDate"] = "2week";
      } else if (val.includes("1month")) {
        state.searchDateSelection["dropdownDate"] = "1month";
      } else if (val.includes("3month")) {
        state.searchDateSelection["dropdownDate"] = "3month";
      } else if (val.includes("6month")) {
        state.searchDateSelection["dropdownDate"] = "6month";
      } else if (val.includes("1year")) {
        state.searchDateSelection["dropdownDate"] = "1year";
      }
      //dropdown start date
    } else if (keys.includes("dropdownStart")) {
      state.searchDateSelection["dropdownStart"] = payload["dropdownStart"];
    } else if (keys.includes("approvedDate")) {
      state.searchDateSelection["approvedDate"] = payload["approvedDate"];
    } else if (keys.includes("panelists")) {
      state.searchDateSelection["panelists"] = payload["panelists"];
    } else if (keys.includes("country")) {
      state.searchDateSelection["country"] = payload["country"];
    } else if (keys.includes("company")) {
      state.searchDateSelection["company"] = payload["company"];
    } else if (keys.includes("affinity_association")) {
      state.searchDateSelection["affinity_association"] =
        payload["affinity_association"];
    } else if (keys.includes("productName")) {
      state.searchDateSelection["productName"] = payload["productName"];
    } else if (keys.includes("choosenCompanies")) {
      state.searchDateSelection["choosenCompanies"] =
        payload["choosenCompanies"];
    }
    // console.log(state.searchDateSelection, 44);
  },
};
export default mutations;
